(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('PlayIntegrityLogDeleteController',PlayIntegrityLogDeleteController);

    PlayIntegrityLogDeleteController.$inject = ['$uibModalInstance', 'entity', 'PlayIntegrityLog'];

    function PlayIntegrityLogDeleteController($uibModalInstance, entity, PlayIntegrityLog) {
        var vm = this;

        vm.playIntegrityLog = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PlayIntegrityLog.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
